export default {
  fixed: [
    // 采购商城 - 公告详情
    {
      path: '/notice',
      name: 'notice',
      component: () => import(/* webpackChunkName: "notice" */'../routes/notice/index.vue'),
      meta: {
        title: {
          'zh-CN': '公告',
          en: '公告_en',
          jp: '公告_jp'
        },
        spmB: 'b19',
        isNewHeader: true
      }
    },
    // 帮助中心
    {
      path: '/help/list',
      name: 'help-list',
      component: () => import(/* webpackChunkName: "notice" */'fe-coms/components/business/ai-service/help/list.vue'),
      meta: {
        title: {
          'zh-CN': '帮助中心',
          en: '帮助中心_en',
          jp: '帮助中心_jp'
        },
        spmB: 'b456',
        noTranslation: true,
        isNewHeader: true
      }
    },
    // 帮助中心详情
    {
      path: '/help/detail',
      name: 'help-detail',
      component: () => import(/* webpackChunkName: "notice" */'fe-coms/components/business/ai-service/help/detail.vue'),
      meta: {
        title: {
          'zh-CN': '帮助中心详情',
          en: '帮助中心详情_en',
          jp: '帮助中心详情_jp'
        },
        spmB: 'b457',
        noTranslation: true,
        isNewHeader: true
      }
    }
  ]
}
